import * as React from 'react';
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';
import { useState } from 'react';
import {
    Value,
    Values,
} from 'one-ui-values';

import Select from 'antd/lib/select';

const {
    Option,
} = Select;

import {
    PatientAdditionalInfoCardProps,
} from './props';

import {
    PatientAdditionalInfoModel
} from './model';

import {
    CardLight,
} from 'one-ui-card/src/card-light';
import {
    CardNoData
} from 'one-ui-card';
import {
    checkCardHasError,
    CardErrorMsg,
    CardLockIcon
} from 'one-card-notification';
import { useCtx } from "one-ui-provider";
import {FinessePhonePlugin} from 'one-comp-phone'
/**
 * This function returns the Additional Information
 * @param props component property
 * @returns JSX code Additional Information Card
 */
export const PatientAdditionalInfoCard = <M extends PatientAdditionalInfoModel>(
    props: PatientAdditionalInfoCardProps<M>
) => {
    const {
        model,
        title,
    } = props;
    const {
        subjects,
        selected
    } = model || {};
    const { settings } = useCtx();
    const { uisettings: { dashboardcardconfig } } = settings;
    const [dataIndex, setdataIndex] = useState(0);
    const emergencydata = selected?.emergencycontact;
    let emrgencyname = (
        <Values >
            <Value
                label="Name"
                value={emergencydata?.[dataIndex]?.emergename}
            />
        </Values>

    )
    if (selected?.emergencycontact?.length > 1) {
        emrgencyname = (
            <>
                <Value
                    label="Name"
                />
                <Select
                    size="small"
                    value={emergencydata?.[dataIndex]?.emergename ? emergencydata[dataIndex].emergename : ""}
                    style={{ width: 240 }}
                    onSelect={(value: any) => {
                        let index = selected.emergencycontact.findIndex((patientdata: any) => patientdata.emergename === value);
                        setdataIndex(index);
                    }}
                >
                    {
                        (selected) && selected.emergencycontact.map((emergency: any, index: number) =>
                            (
                                <Option value={emergency.emergename} key={index} >{emergency.emergename}</Option>
                            ))

                    }
                </Select>
            </>
        )
    }

    let addinfoUI = (
        <>
            <Row gutter={[4, 4]}>
                <Col span={24} >
                    {emrgencyname}
                </Col>
            </Row>
            <Row gutter={[16, 4]}>
            <Col span = {24}>
            <Values>
            <FinessePhonePlugin 
                label='Contact Number'
                phone={emergencydata?.[dataIndex]?.contactnumber}
            />
            </Values>
            </Col>
           {/* <Col span={10}>
            <Values>
                <Value
                    label="Race"
                    value={selected?.race}
                />
                </Values>
            </Col>*/}
            </Row>
            <Row gutter={[16, 4]}>
            <Col span ={24}>
            <Values>
                <Value
                    label="Relation"
                    value={emergencydata?.[dataIndex]?.contactrelation ? emergencydata[dataIndex].contactrelation : ""}
                />
            </Values>
            </Col>
            {/*<Col span = {10}>
            <Values>
                <Value
                    label="Email"
                    value={selected?.email}
                />
            </Values>
            </Col>*/}
            </Row>
        </>

    );
    // }
    // check for the no details found on api response
    if ((subjects?.length === 0 && selected === undefined) ||
        (emergencydata?.[dataIndex]?.emergename === null || 
        emergencydata?.[dataIndex]?.emergename === ''||
        emergencydata?.[dataIndex]?.emergename === undefined)) {
        addinfoUI = (
            <CardNoData />
        )
    }

    if(checkCardHasError('Subject') && 
       ((subjects?.length === 0 && selected === undefined) ||
       (emergencydata?.[dataIndex]?.emergename === null || 
       emergencydata?.[dataIndex]?.emergename === ''||
       emergencydata?.[dataIndex]?.emergename === undefined))){
        addinfoUI = (<CardErrorMsg />)
    }
    // Based on emergencyContact flag If emergencyContact flag set as false then Lock Icon Will Show
    if (!dashboardcardconfig?.emergencyContact){
        addinfoUI = 
        <>
            <CardLockIcon />
        </>
    }
    return (
        <CardLight
            title={title}
            body={(
                <>
                    {addinfoUI}
                </>
            )}
        />
    );
};
